import * as React from 'react';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { __ } from 'react-i18n';
import { SvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  text: string;
  onClick: any;
  iconType: string;
}

export function MobileCategoryFilterButton({ text, onClick, iconType }: Props) {
  return (
    <Wrapper onClick={onClick}>
      <StyledSvgIcon
        icon={iconType === 'FILTER' ? IconType.filter : IconType.category}
        title={text}
        alt={text}
        marginRight={12}
        cursor="pointer"
      />
      <Text>{text}</Text>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  padding: ${rem(8)};
  width: 50%;
  cursor: pointer;

  ${({ theme }) => theme.mediab.l925`
      justify-content: center;
  `}
`;

const StyledSvgIcon = styled(SvgIcon)`
  fill: ${({ theme }) => theme.colors.primary};
`;

const Text = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  font-weight: 500;
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
`;
